import { FTNodeOptions, ExtendedFTNode } from "src/typings/flexFramework/FlexComponent";

//TODO: delete this method when blossom is 100% template based rendering

/**
 * Necessary for Composition based rendering only. Normalizes options data across Composition and Template based rendering. Where there is overlap, data from flexTemplateNode.options will take precedence over model from Composition. Useful for clientSideOnly modules and other components with no backing microservice, where Flex Compositor will put all moduleDefinition params into the model. Also useful for older components whose mock data for testing is based on Composition rendering
 * @param flexTemplateNode
 * @param model
 */
export const normalizeOptionsData = (flexTemplateNode: ExtendedFTNode, model: any): FTNodeOptions => {
  flexTemplateNode.options = {
    ...model,
    ...flexTemplateNode.options,
  };

  return flexTemplateNode.options;
};
